import { useForm } from 'react-hook-form';

import usePostFeedbackMutation from '~hooks/query/wanted/usePostFeedback';

export interface IFeedbackForm {
  email: string;
  feedback: string;
  policy: boolean;
}
export function useFeedbackForm() {
  const { register, handleSubmit, formState, watch, reset } = useForm<IFeedbackForm>({
    mode: 'all',
  });
  const { mutate } = usePostFeedbackMutation();

  function onSubmit(data: IFeedbackForm) {
    mutate({ email: data.email, feedback: data.feedback });
  }

  const registers = {
    email: register('email', {
      required: true,
      validate: {
        validValue: () => {
          const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
          const email = watch('email');

          return emailRegex.test(email);
        },
      },
    }),
    feedback: register('feedback', { required: true }),
    policy: register('policy', { required: true }),
  };

  const resetForm = () => {
    reset({});
  };

  return {
    registers,
    handleSubmit: handleSubmit((data) => {
      onSubmit(data);
      resetForm();
    }),
    formState,
    resetForm,
  };
}
